import twoFactorAuth from './2fa.json';
import notFound from './404.json';
import account from './account.json';
import { admin } from './admin';
import adminFantasy from './admin/fantasy.json';
import artifacts from './artifacts.json';
import auth from './auth.json';
import collection from './collection.json';
import commonEN from './common.json';
import connectWallet from './connect-wallet.json';
import dashboard from './dashboard.json';
import dashboardCards from './dashboard_cards.json';
import copyWidget from './elements/copy_widget.json';
import emojiEn from './emoji.json';
import exploreEN from './explore.json';
import { fantasyWishlist } from './fantasy';
import floorgame from './floorgame.json';
import globalSearch from './global_search.json';
import gridItem from './grid_items.json';
import groups from './groups.json';
import invites from './invites.json';
import marketplace from './marketplace.json';
import myEmojisEN from './my_emojis.json';
import navigation from './navigation.json';
import nft from './nft.json';
import nftDetails from './nft_details.json';
import onboarding from './onboarding.json';
import partnerIntegrations from './partner_integrations.json';
import paymentEN from './payment.json';
import powerUps from './power_ups.json';
import primaryYat from './primary_yat.json';
import prismCases from './prism_cases.json';
import promoCodes from './promo_codes.json';
import statsCard from './stats_card.json';
import transfers from './transfers.json';
import translationEN from './translation.json';
import waitlist from './waitlist.json';
import wallet from './wallet.json';
import walletManager from './wallet_manager.json';
import wishlist from './wishlist.json';
import wordsEN from './words.json';
import yatConnect from './yat_connect.json';
import yatIntro from './yat_intro.json';
import yatNFTManager from './yat_nft_manager.json';
import yatPage from './yat_page.json';
import yatPicker from './yat_picker.json';
import yatSync from './yat_sync.json';
import yatTypes from './yat_types.json';

export const translationsEn = {
    twoFactorAuth,
    notFound,
    account,
    admin,
    auth,
    adminFantasy,
    artifacts,
    collection,
    commonEN,
    connectWallet,
    dashboard,
    dashboardCards,
    copyWidget,
    emojiEn,
    exploreEN,
    fantasyWishlist,
    floorgame,
    globalSearch,
    gridItem,
    groups,
    invites,
    marketplace,
    myEmojisEN,
    navigation,
    nft,
    nftDetails,
    onboarding,
    partnerIntegrations,
    paymentEN,
    powerUps,
    primaryYat,
    prismCases,
    promoCodes,
    statsCard,
    transfers,
    translationEN,
    waitlist,
    wallet,
    walletManager,
    wordsEN,
    wishlist,
    yatConnect,
    yatNFTManager,
    yatPage,
    yatPicker,
    yatSync,
    yatTypes,
    yatIntro,
};
